/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By calendar subtraction: we count the whole years from your birth date, then the whole months left after that, then the remaining days — the same way you'd say it in conversation (e.g. 34 years, 2 months, 5 days). This is more accurate than estimating from total days divided by 30, since months vary from 28 to 31 days.`)
};

const es_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por resta de calendario: contamos los años completos desde tu fecha de nacimiento, luego los meses completos restantes después de eso, luego los días restantes — de la misma manera que lo dirías en conversación (p. ej. 34 años, 2 meses, 5 días). Esto es más preciso que estimar a partir de días totales divididos por 30, ya que los meses varían de 28 a 31 días.`)
};

const de_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durch Kalendersubtraktion: Wir zählen die ganzen Jahre von Ihrem Geburtsdatum, dann die ganzen Monate danach, dann die verbleibenden Tage — genauso wie Sie es im Gespräch sagen würden (z. B. 34 Jahre, 2 Monate, 5 Tage). Dies ist genauer als eine Schätzung aus Gesamttagen dividiert durch 30, da Monate zwischen 28 und 31 Tagen variieren.`)
};

const nl_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Door kalenderaftrekking: we tellen de volledige jaren vanaf uw geboortedatum, dan de volledige maanden die overblijven na die jaren, dan de resterende dagen — op dezelfde manier als u het in een gesprek zou zeggen (bijv. 34 jaar, 2 maanden, 5 dagen). Dit is nauwkeuriger dan schatten uit totale dagen gedeeld door 30, aangezien maanden van 28 tot 31 dagen variëren.`)
};

const fr_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Par soustraction calendaire : nous comptons les années entières à partir de votre date de naissance, puis les mois entiers restants après cela, puis les jours restants — de la même manière que vous le diriez dans la conversation (par exemple, 34 ans, 2 mois, 5 jours). C'est plus précis que d'estimer à partir du nombre total de jours divisé par 30, puisque les mois varient de 28 à 31 jours.`)
};

const it_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Per sottrazione calendario: contiamo gli anni interi dalla tua data di nascita, poi i mesi interi rimasti dopo questo, poi i giorni rimanenti — nello stesso modo in cui lo diresti in una conversazione (ad es. 34 anni, 2 mesi, 5 giorni). Questo è più accurato della stima dai giorni totali divisi per 30, poiché i mesi variano da 28 a 31 giorni.`)
};

const pt_br2_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por subtração no calendário: contamos os anos completos a partir de sua data de nascimento, depois os meses completos restantes e depois os dias restantes — da mesma forma que você diria em uma conversa (por exemplo, 34 anos, 2 meses, 5 dias). Isso é mais preciso do que estimar a partir do total de dias dividido por 30, já que os meses variam de 28 a 31 dias.`)
};

const pt_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por subtração de calendário: contamos os anos inteiros a partir da sua data de nascimento, depois os meses inteiros que sobram depois disso, depois os dias restantes — da mesma forma que o diria em conversa (por exemplo, 34 anos, 2 meses, 5 dias). Isto é mais preciso do que estimar a partir de dias totais divididos por 30, uma vez que os meses variam de 28 a 31 dias.`)
};

const ja_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カレンダーの減算によって：生年月日からの完全な年、その後に残された完全な月、その後に残された日を数えます - 会話で言うのと同じ方法（例：34年2ヶ月5日）。月は28〜31日の範囲があるため、総日数を30で割って推定するより正確です。`)
};

const zh_age_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`通过日历减法计算：我们先计算从出生日期起的整年数，再计算之后剩余的整月数，最后计算剩余的天数——就像您在日常对话中所说的那样（例如 34 岁 2 个月 5 天）。由于月份天数在 28 到 31 天之间不等，这比用总天数除以 30 来估算更加准确。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const age_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.age_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("age_faq1_a", locale)
	if (locale === "en") return en_age_faq1_a(inputs)
	if (locale === "es") return es_age_faq1_a(inputs)
	if (locale === "de") return de_age_faq1_a(inputs)
	if (locale === "nl") return nl_age_faq1_a(inputs)
	if (locale === "fr") return fr_age_faq1_a(inputs)
	if (locale === "it") return it_age_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_age_faq1_a(inputs)
	if (locale === "pt") return pt_age_faq1_a(inputs)
	if (locale === "ja") return ja_age_faq1_a(inputs)
	return zh_age_faq1_a(inputs)
};